import _ from 'lodash';
import { CustomQuoteService } from 'twia-capability-quoteandbind-residential';
import messages from "../pages/Quote/QuotePage.messages.js"

// US26348
const printDocument = (submissionVM, showConfirm, showAlert, translator, authHeader) => {
    const ACTION_MSG = {
        confirmAction: {
            title: "",
            message: translator(messages.documentMessage),
            status: 'info',
            icon: 'mi-error-outline',
            confirmButtonText: translator(messages.documentConfirmButton),
            cancelButtonText: translator(messages.documentContinueButton),
        },
        errorAction: {
            title: translator(messages.documentErrorTitle),
            message: translator(messages.documentErrorMessage),
            status: 'error',
            icon: 'mi-error-outline',
            cancelButtonText: translator(messages.documentCloseButton),
        },
        cancelQuoteAction: {
            title: translator(messages.cancelQuote),
            message: translator(messages.cancelMessage),
            status: 'warning',
            icon: 'mi-error-outline',
            confirmButtonText: translator(messages.cancelMessageYesButton),
            cancelButtonText: translator(messages.cancelMessageButton),
        }
    };

    const messageConfirmAction = ACTION_MSG.confirmAction;
    const messageErrorAction = ACTION_MSG.errorAction;
    const messageCancelAction = ACTION_MSG.cancelQuoteAction;
    let quoteStatus = '';
    let publicID = '';
    const jobType = _.get(submissionVM, 'baseData.jobType.value')?.code;
    let quoteID 

    if(jobType === 'Renewal' || jobType === 'PolicyChange') {
        quoteID = _.get(submissionVM, 'jobID')?.value
    } else {
        quoteID = _.get(submissionVM, 'quoteID')?.value
    }
    
    if (submissionVM.quoteData.offeredQuotes.length === 1) {

        quoteStatus = submissionVM.value.quoteData.offeredQuotes[0].status;
        publicID = submissionVM.value.quoteData.offeredQuotes[0].publicID;
    } else if (submissionVM.quoteData.offeredQuotes.length > 1) {

        quoteStatus = submissionVM.value.quoteData.offeredQuotes[1].status;
        publicID = submissionVM.value.quoteData.offeredQuotes[1].publicID;
    }

    // DE18874
    if (quoteStatus === 'Quoted' || quoteStatus === 'Renewing') {
        CustomQuoteService.generateDocument_TWIA(publicID, 'quoteSummary', authHeader).then((response) => {
            showConfirm(messageConfirmAction).then(results => {
                // DE17292,DE17237
                let path

                if(jobType === 'Renewal') {
                    path = `${process.env.PUBLIC_PATH}/renewal/${quoteID}/documents`
                } else if(jobType === 'PolicyChange') {
                    path = `${process.env.PUBLIC_PATH}/change/${quoteID}/documents`
                } else {
                    path = `${process.env.PUBLIC_PATH}/quotes/${quoteID}/documents`
                }

                if (results === 'confirm') {
                    showConfirm(messageCancelAction).then(result => {
                        if (result === 'confirm') {
                            window.open(path, '_self')
                        }

                    })

                }
            })
        })
    } else {
        // eslint-disable-next-line @typescript-eslint/no-empty-function
        showAlert(messageErrorAction).then(results => {

        })
    }

}

export default {
    'printDocument': printDocument
}